import { render, staticRenderFns } from "./Jsrybg.vue?vue&type=template&id=8807bbb0"
import script from "./Jsrybg.vue?vue&type=script&lang=js"
export * from "./Jsrybg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports